<div class="row">
    <div class="col-6">
        <h2>Onboarding Images</h2>
    </div>
    <div class="col-sm-6">
        <!-- <button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onBack()">
            Back
        </button> -->
        <button type="submit" (click)="onSubmit()" style="float: right;" class="btn btn-primary px-4">
            Save
        </button>
    </div>
</div>
<div class="row">
    <nb-card>
        <nb-card-body style="position: relative">
            <form [formGroup]="imageForm">
                <div class=" col-sm-3">
                    <span>
                        <!-- <h4>Select Language</h4> -->
                        <ng-select [items]="selectedLanguage" bindLabel="lable" bindValue="value"
                            placeholder="Select Language" required formControlName="language"
                            (change)="getUploadImages()" [clearable]="false"></ng-select>
                    </span>
                </div>
                <div class=" row">
                    <div class="col-sm-4 mt-4">
                        <!-- <label>Logo</label><br /> -->
                        <div class="imageWidth">
                            <label class="file">
                                <input type="file" name="logo" accept="image/*" id="exampleInputFile"
                                    (change)="updateImage($event,'Image1')" formControlName="image1" />
                                <span *ngIf="!image1"><img src="assets/images/plusnew.png " height="80" /></span>
                                <span *ngIf="image1"><img src="{{ image1 }}" height="80" /></span>
                                <span> </span>
                                <i *ngIf="image1" (change)="updateImage($event,'Image1' )"
                                    class="fa-regular fa-pen-to-square"></i>
                                <!-- <i *ngIf="image1" (click)="removeImage('Image1')" class="fa-solid fa-trash-can"></i> -->
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-4 mt-4">
                        <!-- <label>Logo</label><br /> -->
                        <div class="imageWidth">
                            <label class="file">
                                <input type="file" name="logo" accept="image/*" id="exampleInputFile"
                                    (change)="updateImage($event,'Image2')" formControlName="image2" />
                                <span *ngIf="!image2"><img src="assets/images/plusnew.png " height="80" /></span>
                                <span *ngIf="image2"><img src="{{ image2 }}" height="80" /></span>
                                <span> </span>
                                <i *ngIf="image2" (change)="updateImage($event, 'Image2')"
                                    class="fa-regular fa-pen-to-square"></i>
                                <!-- <i *ngIf="image2" (click)="removeImage('Image2')" class="fa-solid fa-trash-can"></i> -->
                            </label>
                        </div>
                    </div>
                </div>
                <div class=" row " style="margin-top: 20px">
                    <div class="col-sm-4 mt-4">
                        <!-- <label>Logo</label><br /> -->
                        <div class="imageWidth">
                            <label class="file">
                                <input type="file" name="logo" accept="image/*" id="exampleInputFile"
                                    (change)="updateImage($event,'Image3')" formControlName="image3" />
                                <span *ngIf="!image3"><img src="assets/images/plusnew.png " height="80" /></span>
                                <span *ngIf="image3"><img src="{{ image3 }}" height="80" /></span>
                                <span> </span>
                                <i *ngIf="image3" (change)="updateImage($event, 'Image3')"
                                    class="fa-regular fa-pen-to-square"></i>
                                <!-- <i *ngIf="image3" (click)="removeImage('Image3')" class="fa-solid fa-trash-can"></i> -->
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-4 mt-4">
                        <!-- <label>Logo</label><br /> -->
                        <div class="imageWidth">
                            <label class="file">
                                <input type="file" name="logo" accept="image/*" id="exampleInputFile"
                                    (change)="updateImage($event,'image')" formControlName="image4" />
                                <span *ngIf="!image4"><img src="assets/images/plusnew.png " height="80" /></span>
                                <span *ngIf="image4"><img src="{{ image4 }}" height="80" /></span>
                                <span> </span>
                                <i *ngIf="image4" (change)="updateImage($event, 'Image4')"
                                    class="fa-regular fa-pen-to-square"></i>
                                <!-- <i *ngIf="image4" (click)="removeImage('image')" class="fa-solid fa-trash-can"></i> -->
                            </label>
                        </div>
                    </div>
                </div>
            </form>
        </nb-card-body>
    </nb-card>
</div>